<template>
  <v-container fluid>
    <v-form ref="form" @submit.prevent="save(false)">
      <v-row>
        <form-header :title="isEditing ?'Modifica banner' : 'Nuovo banner'"
                     @back="$router.replace('/banners')" @saveback="save(true)" :loading="loading"></form-header>
        <v-col cols="12" md="6" lg="5" xl="4">
          <v-text-field
              label="Nome*"
              v-model="editingItem.title"
              :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="5" xl="4">
          <v-text-field
              label="Link"
              v-model="editingItem.link"
              :rules="[rules.link]"
              hint="deve iniziare per https://"
              persistent-hint
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="6">
          <media-field label="Immagine banner" media-type="banner" :aspect-ratio="320/50" required v-model="editingItem.media_id"></media-field>
        </v-col>

        <v-col cols="12" class="py-0"></v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field type="date" label="Visibile fino al" v-model="expire" ></v-text-field>
        </v-col>


        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field type="number" step="1" label="Priorità" v-model="editingItem.priority" hint="quanto più alto è il valore prima si vede" persistent-hint></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-switch label="Pubblicato" v-model="editingItem.pub" ></v-switch>
        </v-col>

        <form-footer @back="$router.replace('/banners')" @saveback="save(true)" :loading="loading"></form-footer>
      </v-row>
    </v-form>
  </v-container>
</template>

<script lang="ts">
import utils from "../utils";
import rules from "../utils/rules";
import FormHeader from "@/components/FormHeader.vue";
import FormFooter from "@/components/FormFooter.vue";
import {computed, inject, onMounted, ref, useTemplateRef} from "vue";
import type {Auth} from "@/plugins/auth.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Globals} from "@/plugins/globals.ts";
import {useRoute, useRouter} from "vue-router";
import api from "@/api";
import {VForm} from "vuetify/components";
import type { Banner } from "@/models.ts";
import MediaField from "@/components/MediaField.vue";
import {DateTime} from "luxon";
export default {
  components: {MediaField, FormFooter, FormHeader},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const route = useRoute()
    const router = useRouter()
    const form = useTemplateRef<typeof VForm>('form')
    const loading = ref(false)

    const editingItem = ref<Banner>({
      duration: 0, link: "", media_id: "", priority: 0, pub: false, title: ""
    })

    const loadData = async () => {
      loading.value = true;
      let id = route.params.id as string;
      const res = await api.get<Banner>('banners', id)
      if(!res.success) {
        loading.value = false;
        messages.error(res.message ?? Msg.serverError)
        await router.replace('/banners')
        return
      }
      editingItem.value = res.data!
      loading.value = false;
    }

    onMounted(async ()=>{
      await globals.waitForInit
      await router.isReady()
      await Promise.all([
          globals.refreshEmpty('media')
      ])
      if (route.params.id !== "new") {
        await loadData();
      }
    })




    return {
      form,
      loading,
      isEditing : computed(()=> route.params.id !== "new"),
      editingItem,
      rules,
      formatDate : utils.formatDate,
      expire : computed<string|undefined>({
        get() {
          if(!editingItem.value.exp) return undefined
          const dt = DateTime.fromISO(editingItem.value.exp)
          if(!dt || !dt.isValid) return undefined
          return dt.toISODate()
        },
        set(val:string|undefined) {
          if(!val) {
            editingItem.value.exp = undefined
            return
          }
          const dt = DateTime.fromISO(val)
          if(!dt || !dt.isValid) {
            editingItem.value.exp = undefined
            return
          }
          editingItem.value.exp = dt.toISO()
        }
      }),
      async save(goBackAfterSave:boolean) {
        editingItem.value.priority  = utils.toInt(editingItem.value.priority, 0)

        const v = await form.value!.validate()
        if(!v.valid) return;
        loading.value = true;

        const res = await api.save<Banner>('banners', editingItem.value)
        loading.value = false;
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          if(res.status === 401) {
            auth.logout()
          }
          return
        }
        editingItem.value = res.data!
        messages.success("nome salvato")
        if(goBackAfterSave) {
          await router.replace('/banners')
        } else if(route.params.id === 'new'){
          await router.replace(`/banners/${editingItem.value._id}`)
        }
      }
    };
  }
};
</script>

<style scoped></style>
